import React, { Component } from 'react'
import Link from 'gatsby-link'

import styles from './contact.module.css'

class Contact extends Component {
  render() {
    return (
      <div
        className={styles.contact}
      >
        <form
          action="/"
          className={styles.contactForm} 
          name="contact" 
          method="POST" 
          data-netlify
        >
          <input type="hidden" name="form-name" value="contact"/>
          <label 
            className={styles.label} 
            htmlFor=""
            >Name</label>
          <input 
            className={styles.formInput}
            name="name"
            placeholder="name"
            type="text"
            />
          <label 
            className={styles.label} 
            htmlFor=""
            >Email</label>
          <input 
            className={styles.formInput} 
            name="email"
            placeholder="email"
            type="text"
            />
          <label 
            className={styles.label} 
            htmlFor=""
            >Message</label>
          <textarea 
            className={styles.formInput} 
            name="message" 
            id="" 
            cols="30" 
            placeholder="message"
            rows="6"
            ></textarea>
          <input 
            className={styles.formInput} 
            type="submit" value="submit"
          />
        </form>
        <Link 
          className={styles.back}
          to="/"
        >
          &lt;-- back
        </Link>
      </div>
    )
  }
}

export default Contact



// WEBPACK FOOTER //
// ./src/pages/contact.js